<img class="menu-logo" src="assets/logo{{ isDarkTheme ? '-dark' : '' }}.svg" alt="InsightDX" />
